<rk-page-title [title]="'SCHEDULE.PROGRAMS.EDIT_PLAYLIST' | translate"></rk-page-title>
<form [formGroup]="editPlaylistForm" class="add-playlist-form">
  <div *ngIf="(playlists$ | async)?.length">
    <rk-dropdown-autocomplete
      formControlName="selectedPlaylist"
      [label]="'MODAL.ADD_PLAYLIST.PLAYLIST' | translate"
      [data]="playlists$ | async"
      [modal]="true"
      [dropdownWidth]="220"
      [playlistTemplate]="true"
      [placeholder]="'PLAYLIST.SEARCH_BAR.PLACEHOLDER' | translate"
      (click)="openPlaylistSelector($event)"
    ></rk-dropdown-autocomplete>
  </div>

  <rk-form-field [label]="'MODAL.ADD_PLAYLIST.TYPE' | translate">
    <mat-button-toggle-group formControlName="sorting" class="mt-2.5 mb-7">
      <mat-button-toggle value="Sequential">
        <mat-icon fontSet="fa" fontIcon="fa-list"></mat-icon>
        {{ 'MODAL.ADD_PLAYLIST.SEQUENTIAL' | translate }}
      </mat-button-toggle>
      <mat-button-toggle value="Random">
        <mat-icon fontSet="fa" fontIcon="fa-random"></mat-icon>
        {{ 'MODAL.ADD_PLAYLIST.RANDOM' | translate }}
      </mat-button-toggle>
    </mat-button-toggle-group>
  </rk-form-field>

  <rk-form-field
    [label]="'MODAL.ADD_PLAYLIST.TRACKS_NUMBER' | translate"
    hintLocation="between"
    [hintLabel]="'MODAL.ADD_PLAYLIST.HINT_TRACKS_NUMBER' | translate"
  >
    <input
      rkInput
      type="number"
      inputType="num"
      formControlName="tracksNumber"
      pKeyFilter="num"
      min="1"
    />
  </rk-form-field>
</form>
<rk-footer-actions
  (submitted)="submit()"
  (cancelled)="onCancel()"
  [disabledSubmit]="!editPlaylistForm || !editPlaylistForm"
  [forceLeft]="true"
></rk-footer-actions>

<div class="change-playlist-popover" [class.show]="$addingPlaylist()">
  <rk-mob-program-change-playlist
    (applyPlaylist)="applyPlaylist($event)"
  ></rk-mob-program-change-playlist>
</div>
